import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useEffect } from "react";
import { isLogrocketEnabled, startLogrocket } from "utils/logrocket";

export const useLogrocketRecording = (ready: boolean) => {
  const { enableLogrocket } = useFeatureFlags();

  useEffect(() => {
    if (ready && isLogrocketEnabled(enableLogrocket)) void startLogrocket();
  }, [enableLogrocket, ready]);
};
